











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaAryzta} from '@/model/resource/CargaAryzta'
import {CargaAryztaCollection} from '@/model/collection/CargaAryztaCollection'
import {ListCargaAryztaSchema} from '@/schema/resource/CargaAryzta/ListCargaAryztaSchema'
import {CsvCargaAryztaSchema} from '@/schema/resource/CargaAryzta/CsvCargaAryztaSchema'

@Component
export default class ListCargaAryztaView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaAryztaSchema()
  collection = new CargaAryztaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaAryzta) {
    Helper.pushByName('editCargaAryzta', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaAryztaCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaAryzta()
    new CsvCargaAryztaSchema().downloadCsv(csv.all())
  }
}
